// Funzione per avviare il countdown fino alle 8 del mattino
function startCountdownTimer(display) {
  function getNext8AM() {
    const now = new Date();
    let next8AM = new Date();
    next8AM.setHours(8, 0, 0, 0); 
    if (now >= next8AM) {
      next8AM.setDate(next8AM.getDate() + 1);
    }
    return next8AM.getTime(); 
  }

  function updateTimer() {
    const now = new Date().getTime();
    const targetTime = getNext8AM();
    let timeLeft = Math.floor((targetTime - now) / 1000); 
    if (timeLeft < 0) timeLeft = 0; 
    
    const hours = String(Math.floor(timeLeft / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((timeLeft % 3600) / 60)).padStart(2, "0");
    const seconds = String(timeLeft % 60).padStart(2, "0");
    display.textContent = `${hours}h:${minutes}m:${seconds}s`;
  }

  updateTimer();
  setInterval(updateTimer, 1000);
}

document.addEventListener("DOMContentLoaded", function () {
  const display = document.getElementById("countdown-timer");
  if (display) {
    startCountdownTimer(display);
  }
  updateDeliveryDates();

  const selectElement = document.querySelector(".select__select");
  if (selectElement) {
    let previousValue = selectElement.value;
    selectElement.addEventListener("change", function () {
      const currentValue = selectElement.value;
      if (currentValue !== previousValue) {
        previousValue = currentValue;
        updateDeliveryDates();
      }
    });
  }
});

function calculateDeliveryRange(currentDate, startDays, endDays) {
  const currentHour = currentDate.getHours();
  const currentMinute = currentDate.getMinutes();
  const isAfter1300 = (currentHour > 13) || (currentHour === 13 && currentMinute >= 30);

  if (isAfter1300) {
    startDays += 1;
    endDays += 1;
  }

  const startDate = calculateDeliveryDate(currentDate, startDays);
  const endDate = calculateDeliveryDate(currentDate, endDays);

  if (startDate.getMonth() === endDate.getMonth()) {
    return `${startDate.getDate()}-${endDate.getDate()} ${formatDateToShortMonth(startDate)}`;
  } else {
    return `${startDate.getDate()} ${formatDateToShortMonth(startDate)} - ${endDate.getDate()} ${formatDateToShortMonth(endDate)}`;
  }
}

function calculateDeliveryDate(currentDate, daysToAdd) {
  let deliveryDate = new Date(currentDate);
  while (daysToAdd > 0) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
    const dayOfWeek = deliveryDate.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      daysToAdd--;
    }
  }
  return deliveryDate;
}

function formatDateToShortMonth(date) {
  const months = [
    "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
    "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
  ];
  return months[date.getMonth()];
}

function updateDeliveryDates() {
  const selectElement = document.querySelector(".select__select");
  let magazzino = null;

  if (selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    magazzino = selectedOption.getAttribute("data-magazzino");
  } else {
    const productElement = document.querySelector("[data-product-magazzino]");
    if (productElement) {
      magazzino = productElement.getAttribute("data-product-magazzino");
    }
  }

  let targetId = "delivery-date";
  if (magazzino === "true") {
    updateDeliveryDateRange(targetId, 1, 2);
  } else if (magazzino === "false") {
    updateDeliveryDateRange(targetId, 4, 5);
  } else {
    updateDeliveryDateRange(targetId, 1, 5);
  }
}

function updateDeliveryDateRange(elementId, startDays, endDays) {
  const element = document.getElementById(elementId);
  if (element) {
    const currentDate = new Date();
    const deliveryRange = calculateDeliveryRange(currentDate, startDays, endDays);
    element.innerText = deliveryRange;
  }
}
